module.exports = __webpack_public_path__ + "img/login-hint-icon.73188bd0.png";